import { Link } from 'react-router-dom';
import VitrineNav from './VitrineNav';
import './LandingPage.css';

export default function Confidentialite() {
  return (
    <div className="vt">
      {/* ⚠️ MÊME DÉFAUT QUE LES MENTIONS LÉGALES, MÊME CORRECTIF, AUCUNE
          VARIANTE : ni logo, ni signature GSS-360 — un `<span>GSS-360</span>`
          nu. Les deux pages avaient divergé de l'accueil parce que l'en-tête
          était recopié dans trois fichiers ; il n'en existe plus qu'un. */}
      <VitrineNav />

      <section className="vt-legal">
        <div className="vt-legal-content">
          <Link to="/" className="vt-legal-back">← Retour à l&apos;accueil</Link>
          <h1>Politique de confidentialité</h1>
          <p className="vt-legal-sub">Dernière mise à jour : juin 2026</p>

          <p>
            Gladiator Security Systems SARL U, éditeur de la plateforme GSS-360, accorde une grande importance
            à la protection de vos données personnelles. Cette politique explique quelles données nous collectons,
            pourquoi, et quels sont vos droits. Elle s'inscrit dans le respect des principes de protection des
            données en vigueur dans la zone OHADA, notamment la Convention de l'Union Africaine sur la
            cybersécurité et la protection des données à caractère personnel (Convention de Malabo)
            et les lois nationales applicables.
          </p>

          <h2>1. Responsable du traitement</h2>
          <p>
            Gladiator Security Systems SARL U<br />
            RCCM TG-LFW-01-2024-B13-00449 — NIF 1001930788<br />
            Tokoin-Wuiti, Rue Air-Burkina, Lomé, Togo<br />
            Contact : formulaire de <Link to="/#demo">demande de démonstration</Link>
          </p>

          <h2>2. Données collectées</h2>
          <p>
            Via le formulaire de demande de démonstration ou de devis, nous collectons :
            nom complet, nom de l'entreprise, adresse e-mail, numéro de téléphone,
            et le message éventuel que vous nous adressez. Nous ne collectons aucune
            autre donnée à votre insu et n'utilisons pas de traceurs publicitaires.
          </p>

          <h2>3. Finalité du traitement</h2>
          <p>
            Ces données sont utilisées uniquement pour : traiter votre demande,
            vous recontacter, et vous présenter nos services. Elles ne servent
            à aucune autre fin.
          </p>

          <h2>4. Base du traitement</h2>
          <p>
            Le traitement repose sur votre consentement, donné au moment où vous
            remplissez et envoyez volontairement le formulaire.
          </p>

          <h2>5. Conservation des données</h2>
          <p>
            Vos données sont conservées le temps nécessaire au traitement de votre
            demande et au suivi commercial, puis supprimées si aucune relation n'est
            établie. Vous pouvez demander leur suppression à tout moment.
          </p>

          <h2>6. Partage des données</h2>
          <p>
            Vos données ne sont ni vendues, ni louées, ni partagées avec des tiers
            à des fins commerciales. Elles sont accessibles uniquement à l'équipe
            de Gladiator Security Systems en charge du suivi de votre demande.
          </p>

          <h2>7. Sécurité</h2>
          <p>
            Vos données sont hébergées sur un serveur sécurisé (connexion chiffrée HTTPS,
            accès restreint, sauvegardes régulières). Nous mettons en œuvre des mesures
            techniques pour les protéger contre tout accès non autorisé.
          </p>

          <h2>8. Vos droits</h2>
          <p>
            Conformément aux textes applicables, vous disposez d'un droit d'accès,
            de rectification et de suppression de vos données, ainsi que du droit
            de retirer votre consentement. Pour exercer ces droits, contactez-nous
            via le formulaire de <Link to="/#demo">demande de démonstration</Link>.
          </p>

          <h2>9. Modifications</h2>
          <p>
            Cette politique peut être mise à jour. La date de dernière mise à jour
            figure en haut de la page.
          </p>
        </div>
      </section>
    </div>
  );
}
